export const defaultColorFilter = {
  type: 'false',
  oneRl: '1',
  twoRl: '2',
  threeRl: '3',
  oneQd: '1',
  twoQd: '2',
  threeQd: '3',
  oneRlColor: '#fff',
  twoRlColor: '#8ad9b5',
  threeRlColor: '#0b65aa',
  fourRlColor: '#e60046',
  oneQdColor: '#fff',
  twoQdColor: '#aaa039',
  threeQdColor: '#aa3939',
  fourQdColor: '#6a8467',
};



// WEBPACK FOOTER //
// ./src/constants/defaultValues.js